import React, { useMemo } from 'react';
import { GetTradingBlockDomain, GetTradingBlockFullUrl } from '../../utilities/site';
import { ExternalLink } from './ExternalLink';
export const TradingBlockLink = ({ to, accountNumber, className, children, origin, siteGroup, config, styleOverride, }) => {
    const domain = useMemo(() => GetTradingBlockDomain(accountNumber, siteGroup, origin), [
        accountNumber,
        siteGroup,
        origin,
    ]);
    const url = useMemo(() => GetTradingBlockFullUrl(to, domain, config, origin), [to, domain]);
    return (React.createElement(ExternalLink, { href: to.includes('LegacySiteHomeUrl') && origin === 'mb' ? 'https://legacy.moneyblock.com/default.aspx' : url, className: className, styleOverride: styleOverride }, children));
};
//# sourceMappingURL=TradingBlockLink.js.map